/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentRetriggerState {
    getFixupPrototypeFunction() { return AssessmentRetriggerState.fixupPrototype; }

    static newInstance(model: Partial<AssessmentRetriggerState>): AssessmentRetriggerState {
        let obj = Object.assign(new AssessmentRetriggerState(), model);
        AssessmentRetriggerState.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentRetriggerState>): AssessmentRetriggerState {
        if (!model) return null;
        return AssessmentRetriggerState.newInstance(<AssessmentRetriggerState> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentRetriggerState) {
        if (!obj) return;

        models.AssessmentRetriggerState.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentRetriggerState): boolean {
        Object.setPrototypeOf(obj, AssessmentRetriggerState.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Assessment Run ID
     */
    assessmentRunID: string;

    /**
     * Assessment Category ID
     */
    assessmentCategoryID: string;

    /**
     * Service Account ID
     */
    serviceAccountID: string;

    /**
     * Assessment Mode
     */
    assessmentMode: string;

    /**
     * Initiated By
     */
    initiatedBy: string;

}
